import { render, staticRenderFns } from "./WXCW03GCGL.vue?vue&type=template&id=4814c06d&scoped=true&"
import script from "./WXCW03GCGL.vue?vue&type=script&lang=js&"
export * from "./WXCW03GCGL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4814c06d",
  null
  
)

export default component.exports